import { FC, useEffect, useState } from "react";
import "./ModalChatsFeedbackAnalysisInsert.scss";
import ModalDefault from "../../ModalDefault/ModalDefault";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../../providers/AuthProvider";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Container, FormGroup, Row } from "react-bootstrap";
import { schema } from "./Validate";
import { ChatFeedbackAnalysisModel } from "../../../models/Chat/ChatFeedbackAnalysisModel";
import ChatMessage from "../ChatMessage/ChatMessage";
import { ChatMessageModel } from "../../../models/Chat/ChatMessageModel";
import ErrorMessage from "../../ErrorMessage/ErrorMessage";
import { useChatsFeedbackAnalysis } from "../../../providers/Chats/ChatsFeedbackAnalysisProvider";

interface ModalChatsFeedbackAnalysisInsertProps {
  show: boolean;
  onClose: () => void;
  vote: ChatFeedbackAnalysisModel;
  analysis?: boolean;
}

const ModalChatsFeedbackAnalysisInsert: FC<
  ModalChatsFeedbackAnalysisInsertProps
> = ({ show, onClose, vote, analysis }) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [chatUserMessage, setChatUserMessage] = useState<ChatMessageModel>({});
  const [chatAgentMessage, setChatAgentMessage] = useState<ChatMessageModel>(
    {}
  );

  const { onInvalid } = useAuth();
  const { handleFetch, setError, handleList } = useChatsFeedbackAnalysis();

  const {
    handleSubmit,
    register,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const handleClose = () => {
    setValue("status_id", 0);
    setValue("vote_id", 0);
    setValue("comment", "");
    setChatUserMessage({});
    setChatAgentMessage({});
    onClose();
  };

  const onSubmit = async (data: any) => {
    setIsLoadingSubmit(true);
    setError("");

    const ret = await handleFetch(data as any);

    if (ret) {
      toast.success("Observação salva com sucesso!");
      handleList();
      handleClose();
    }

    setIsLoadingSubmit(false);
  };

  useEffect(() => {
    if (show) {
      if (vote?.vote_id) {
        setValue("vote_id", vote.vote_id);
        setValue("status_id", 2);
        if (vote?.user_message?.id) {
          const chatUser = new ChatMessageModel();
          chatUser.sender = "user";
          chatUser.content = vote?.user_message?.content;
          chatUser.created_at = vote?.created_at;

          setChatUserMessage(chatUser);
        }

        if (vote?.agent_message?.id) {
          const chatAgent = new ChatMessageModel();
          chatAgent.sender = "agent";
          chatAgent.content = vote?.agent_message?.content;
          chatAgent.created_at = vote?.created_at;

          setChatAgentMessage(chatAgent);
        }
      } else {
        setValue("status_id", 0);
        setValue("vote_id", 0);
        setValue("comment", "");
        setChatUserMessage({});
        setChatAgentMessage({});
      }
    }
  }, [show]);

  return (
    <ModalDefault
      title={analysis ? "Ver Análise" : "Analisar"}
      show={show}
      onClose={handleClose}
      sizeModal={"xl"}
      showFooter={true}
      buttonText={isLoadingSubmit ? "Salvando..." : "Salvar"}
      showButtonSpinner={isLoadingSubmit}
      disabledSubmit={analysis || isLoadingSubmit}
      handleSubmit={handleSubmit(onSubmit)}
      backdrop="static"
      backgroundColor="#f8f9fa"
    >
      <div
        className="ModalChatsFeedbackAnalysisInsert"
        data-testid="ModalChatsFeedbackAnalysisInsert"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/img/background-wrapper.png)`,
          backgroundPosition: "top center",
          backgroundRepeat: "repeat",
        }}
      >
        <Row>
          <Col md={12}>
            <Container>
              <div className="d-flex justify-content-end">
                <div className="user-content-message">
                  <ChatMessage message={chatUserMessage} key={0} />
                </div>
              </div>
              <div className="d-flex justify-content-start">
                <ChatMessage message={chatAgentMessage} key={0} />
              </div>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-4">
            <FormGroup className="form-group">
              <label htmlFor="comment">OBSERVAÇÃO *</label>
              <textarea
                className={`form-control ${onInvalid(errors?.comment)}`}
                id="comment"
                {...register("comment")}
                onChange={(e) => setValue("comment", e.target.value)}
                rows={4}
                value={vote?.comment}
                disabled={analysis}
              ></textarea>
              <ErrorMessage
                name={"Observação"}
                type={errors?.comment?.type?.toString()}
                min={3}
                max={500}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </ModalDefault>
  );
};

export default ModalChatsFeedbackAnalysisInsert;
